import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'Location_positions',
  inputShow: gql`
    query locationPositions($input: LocationPositionQueryInput) {
      locationPositions(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Location Positions',
  },
};
